module.exports = fox._r("images/crowdfunding-bg.jpg", __webpack_public_path__ + "images/crowdfunding-bg.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/crowdfunding-bg.jpg
// module id = 206
// module chunks = 4